import styled from 'styled-components';
import {Button, Checkbox, Radio} from 'antd';


export const StyledDiagnosticButton = styled(Button) <{ color: string; isGray?: boolean }>`
  border: none !important;
  height: 28px;
  color: white !important;
  background-color: ${({color}) => color ?? 'transparent'} !important;
  border-radius: 9px;
  gap: 10px;
  align-items: center;
  display: flex;

  ${({isGray}) => isGray && `
    background: #eeeeee !important;
    color: black !important;
    width: 98px !important;
    justify-content: center !important;
    svg,
    span {
      color: black !important;
      font-size: 12px !important;
    }
  `}
`;

export const StyledLink = styled.a`
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  max-width: calc(100% - 15px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  cursor: pointer;
  text-decoration: underline;
  color: #2D6CCA;
`;

export const TabsContaier = styled.div`
.modal-tabs {
          .ant-tabs-nav {
            background-color: #efefef !important;
            margin: 0 !important;
            .ant-tabs-nav-wrap {
              justify-content: center;
              .ant-tabs-nav-list {
                .ant-tabs-tab-active {
                  .ant-tabs-tab-btn {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: #121212;
                  }
                }
                .ant-tabs-ink-bar {
                  background-color: #2D6CCA !important;
                  height: 5px !important;
                  border-radius: 4px 4px 0px 0px !important;
                }
                .ant-tabs-tab {
                  .ant-tabs-tab-btn {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 400;
                    color: #4E5156 !important;
                  }
                  &:hover {
                    color: #4E5156 !important;
                  }
                }
              }
            }
          }
          .ant-tabs-content-holder {
            .ant-tabs-content {
              .ant-tabs-tabpane {
                .input-wrapper {
                  display: flex;
                  align-items: center;
                  margin-bottom: 12px;
                  .label {
                    font-family: 'Inter', sans-serif;
                    font-size: 12px;
                    font-weight: 400;
                    color: #4E5156;
                  }
                  .ant-col {
                    .text-area {
                      height: 75px;
                      border: 1px solid #D2D2D2;
                      border-radius: 8px;
                      resize: none;
                      &:hover {
                        border: 1px solid #D2D2D2 !important;
                      }
                    }
                    .email-input {
                      height: 38px;
                      border: 1px solid #D2D2D2;
                      border-radius: 8px;
                    }
                    .react-tel-input {
                      .support-phone-input {
                        width: 100% !important;
                        height: 38px !important;
                        border-radius: 8px;

                      }
                      .flag-dropdown {
                        border-radius: 8px 0 0 8px !important;
                      }
                    }  
                  }
                }
              }
            }
          }
        }
`;

export const BannerStyled = styled.div`
  width: 100%;
  height: 46px;
  padding-inline: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 0;
  position: absolute;
  bottom: 4px;
  z-index: 99;
  background-color: #fff;
  padding-inline: 16px;
  
  > p {
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 19px !important;
  margin: 0 !important;
 }
`;

export const ButtonStyled = styled(Button) <{ background?: string }>`
  background-color: ${({background}) => background ?? '#d7e4f5'} !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 30px;
  border-radius: 8px;
  gap: 4px;
  padding-inline: 8px;


  &:hover {
    background-color: ${({background}) => background ?? '#d7e4f5'} !important;
    border: 1px solid transparent !important;
  }

  &:focus {
    background-color: ${({background}) => background ?? '#d7e4f5'} !important;
    border: 1px solid transparent !important;
  }

`;

export const CheckboxStyled = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background: white !important;
    border: 1px solid white !important;
    border-radius: 4px !important;
  }
  .ant-checkbox-inner {
    border: 1px solid #CDCDCD !important;
    background: #FFFFFF !important;
    border-radius: 4px !important;

    &::after {
      border-color: #4E5156; 
    }
  }
`;


export const RadioStyled = styled(Radio)<{ checked?: boolean; success?: boolean }>`
  .ant-radio-inner {
    background-color: #fff !important;
    border-color: ${props => props.checked ? (props.success ? '#1FAC47' : '#F44343') : '#CCCCCC'} !important;
  }
  .ant-radio-checked .ant-radio-inner::after {
    background-color: ${props => props.success ? '#1FAC47' : '#F44343'} !important;
  }
`;
